import { render, staticRenderFns } from "./limits.vue?vue&type=template&id=5dd8850d&scoped=true"
import script from "./limits.vue?vue&type=script&lang=js"
export * from "./limits.vue?vue&type=script&lang=js"
import style0 from "./limits.vue?vue&type=style&index=0&id=5dd8850d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8850d",
  null
  
)

export default component.exports